<template>
  <v-card flat>
    <v-card-title>
      <v-spacer />
      {{ $t("component.title") }}
      <v-spacer />
      <!-- <v-btn :loading="loading" @click="this.getData" class="btn-update">
        <v-icon>mdi-refresh</v-icon>
        {{ $t('component.update') }}
      </v-btn> -->
    </v-card-title>
    <v-divider />
    <div class="row">
      <div class="col-md-12 p-5">
        <data-table
          :columns="columns"
          :data="data"
          :debounce-delay="5000"
          :per-page="perPages"
          :translate="translates"
          orderDir="desc"
          @on-table-props-changed="reloadTable"
          :key="$i18n.locale + 'tb'"
          :itemsPerPageText="$t('table.itemsPerPage')"
          :pageText="$t('table.pageText')"
          :prevText="$t('table.prevText')"
          :nextText="$t('table.nextText')"
          :noDataText="$t('table.noDataText')"
        >
        </data-table>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserInventions from "@/view/pages/invitation/userInventions";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";

export default {
  created() {
    this.getData(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("component.breadcrumb") },
    ]);
  },

  data() {
    return {
      translates: {
        next: this.$t("table.nextText"),
        previous: this.$t("table.prevText"),
        noData: this.$t("table.noDataText"),
        search: this.$t("table.search"),
        itemsPerPage: this.$t("table.itemsPerPage"),
      },
      perPages: [10, 25, 50, 100],
      url: "admin/invent/code",
      data: {},
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      query: { sort: "id", order: "desc", limit: 25, s: "" },
      xprops: {
        module: "ContentIndex",
        route: "content",
        content_prefix: "content_",
        fetchIndexData: "fetchIndexData",
      },
    };
  },

  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters("ContentIndex", ["contents", "total", "loading"]),
    columns() {
      return [
        {
          label: this.$t("component.columns.row"),
          transform: (val) => {
            let row = this.data.meta.current_page - 1;
            row = row * this.data.meta.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: this.$t("component.columns.name"),
          name: "name",
          orderable: true,
        },
        {
          label: this.$t("component.columns.family"),
          name: "family",
        },
        {
          label: this.$t("component.columns.username"),
          name: "username",
          orderable: true,
        },
        {
          label: this.$t("component.columns.phone"),
          name: "phone",
          orderable: true,
        },
        {
          label: this.$t("component.columns.created_at"),
          name: "created_at",
          transform: (val) => {
            return val.data.created_at !== null
              ? this.$options.filters.longDate(val.data.created_at)
              : this.$t("component.unknown");
          },
        },
        {
          label: this.$t("component.columns.actions"),
          name: "actions",
          type: "html",
          component: UserInventions,
          handler: this.action,
          event: "action",
        },
      ];
    },

    config() {
      return this.layoutConfig();
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.translates = {
          next: this.$t("table.nextText"),
          previous: this.$t("table.prevText"),
          noData: this.$t("table.noDataText"),
          search: this.$t("table.search"),
          itemsPerPage: this.$t("table.itemsPerPage"),
        };
        this.reloadTable(this.tableProps);
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    getData(url = this.url, options = this.tableProps) {
      this.requestApiGet(this.url, options).then((response) => {
        this.data = response.data;
      });
    },

    reloadTable(tableProps) {
      this.getData(this.url, tableProps);
    },

    action(data, type) {
      this[type](data);
    },

    history(data) {
      this.$router.push({
        name: "admin.users.history",
        params: { phone: data.phone },
      });
    },
    checkout(data) {
      this.$modal.showLoading();

      this.getUserTokenWithId(data.id)
        .then((token) => {
          try {
            loginRollback.addLogin(this.getUser()?.name, jwtService.getToken());
            jwtService.saveToken(token);
            window.history.pushState(
              "dashboard",
              "dashboard",
              this.$router.resolve({ path: "/dashboard" }).href
            );
            window.location.reload();
          } catch (e) {
            console.log(e);
          }
        })
        .catch(() => {
          this.$toast.error(this.$t("component.error"));
        })
        .finally(() => {
          this.$modal.hideLoading();
        });
    },

    transactions(data) {
      this.$router.push({ name: "user.transactions" });
    },
    ...mapActions("ContentIndex", ["fetchIndexData", "setQuery", "resetState"]),
  },

  beforeDestroy() {
    this.resetState();
  },
};
</script>
